/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductHeatPumpSupplyList } from '../models/PaginatedProductHeatPumpSupplyList';
import type { PatchedProductHeatPumpSupply } from '../models/PatchedProductHeatPumpSupply';
import type { ProductHeatPumpSupply } from '../models/ProductHeatPumpSupply';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsHeatPumpSupplyService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductHeatPumpSupplyList
     * @throws ApiError
     */
    public productsHeatPumpSupplyList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductHeatPumpSupplyList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-heat-pump-supply/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductHeatPumpSupply
     * @throws ApiError
     */
    public productsHeatPumpSupplyCreate({
        requestBody,
    }: {
        requestBody: ProductHeatPumpSupply,
    }): CancelablePromise<ProductHeatPumpSupply> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-heat-pump-supply/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductHeatPumpSupply
     * @throws ApiError
     */
    public productsHeatPumpSupplyRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product heat pump supply.
         */
        id: number,
    }): CancelablePromise<ProductHeatPumpSupply> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-heat-pump-supply/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductHeatPumpSupply
     * @throws ApiError
     */
    public productsHeatPumpSupplyUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product heat pump supply.
         */
        id: number,
        requestBody: ProductHeatPumpSupply,
    }): CancelablePromise<ProductHeatPumpSupply> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-heat-pump-supply/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductHeatPumpSupply
     * @throws ApiError
     */
    public productsHeatPumpSupplyPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product heat pump supply.
         */
        id: number,
        requestBody?: PatchedProductHeatPumpSupply,
    }): CancelablePromise<ProductHeatPumpSupply> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-heat-pump-supply/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsHeatPumpSupplyDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product heat pump supply.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-heat-pump-supply/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
